<div class="titulo-firmantes-solicitudes">
  <p>{{ 'PERFILCREZCAMOS.LBL_FIRMANTESOBLIGACION' | translate | uppercase }}</p>
  <p>{{ row.numeroCredito ? row.numeroCredito : '-' }}</p>
</div>
<div class="table-container">
  <p-table class="tabla-gris" [columns]="columnasFirmantes" [value]="listFirmantes" [paginator]="true"
           [rows]="10" [responsive]="true" paginatorPosition="bottom">

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th class="text-center" [attr.colspan]="12">
          {{ 'PERFILCREZCAMOS.LBL_FIRMANTES' | translate | uppercase }}
        </th>
        <!--<th class="text-center" [attr.colspan]="4" style="border-left: 1px solid #c2c2c2;">
          {{ 'PERFILCREZCAMOS.LBL_REFERENCIAS' | translate | uppercase }}
        </th>-->
      </tr>
      <tr class="table-row-white">
        <th *ngFor="let col of columns; let i = index"
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            class="text-center"
            [ngStyle]="i === 10 ? {'border-left': '1px solid #c2c2c2'} : {}">
          {{ col.header | uppercase }}
          <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-i="rowIndex">
      <tr>
        <!-- Datos del firmante -->
        <td class="text-center">{{ rowData.vinculacion }}</td>
        <td class="text-center">{{ rowData.nombreCompleto }}</td>
        <td class="text-center">{{ rowData.codigoTipoDocumento }}</td>
        <td class="text-center">{{ rowData.numeroDocumento | numero:0 }}</td>
        <td class="text-center">{{ rowData.parentesco }}</td>
        <td class="text-center">{{ formatearTelefono(rowData.telefonoPrincipal) }}</td>
        <td class="text-center">{{ formatearTelefono(rowData.telefonoSecundario) }}</td>
        <td class="text-center">{{ rowData.direccionDomicilio }}</td>
        <td class="text-center">{{ rowData.direccionNegocio }}</td>
        <td class="text-center">{{ rowData.ocupacion }}</td>
        <td class="text-center">{{ rowData.garantiaRespaldo }}</td>
        <td class="text-center">{{ rowData.causal }}</td>
      </tr>

      <!-- p-accordion para las referencias -->
      <tr>
        <td [attr.colspan]="columnasFirmantes.length" style="padding: 0;">
          <p-accordion>
            <p-accordionTab header="{{ 'PERFILCREZCAMOS.LBL_REFERENCIAS' | translate }}">
              <!-- Primera referencia -->
              <ng-container *ngIf="rowData.referencias && rowData.referencias.length > 0">
                <p-table [columns]="columnasFirmantes" [value]="rowData.referencias" [paginator]="false" [rows]="5" [responsive]="true">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th class="text-center">{{ 'PERFILCREZCAMOS.LBL_NOMBRE' | translate }}</th>
                      <th class="text-center">{{ 'PERFILCREZCAMOS.LBL_TELEFONO' | translate }}</th>
                      <th class="text-center">{{ 'PERFILCREZCAMOS.LBL_TIPOREFERENCIA' | translate }}</th>
                      <th class="text-center">{{ 'PERFILCREZCAMOS.LBL_PARENTESCO' | translate }}</th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-referencia>
                    <tr>
                      <td class="text-center">{{ referencia.nombreCompleto | titlecase }}</td>
                      <td class="text-center">{{ formatearTelefono(referencia.telefono) }}</td>
                      <td class="text-center">{{ referencia.tipoReferencia }}</td>
                      <td class="text-center">{{ referencia.parentescoRelacion }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </ng-container>
              <!-- Mensaje si no hay referencias -->
              <ng-container *ngIf="!rowData.referencias || rowData.referencias.length === 0">
                <p>{{ 'PERFILCREZCAMOS.LBL_NOHAYREFERENCIA' | translate }}</p>
              </ng-container>
            </p-accordionTab>
          </p-accordion>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td class="text-center" [attr.colspan]="columns.length">
          {{ row.mensaje ? row.mensaje : 'MSG_NOHAYREGISTROS' | translate }}
        </td>
      </tr>
    </ng-template>

  </p-table>
  <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
                pButton (click)="cerrarModal()"></button>
      </div>
  </div>
  </div>